import React from 'react';
import GallNav from '../Component/Gallnav';

function Gallery() {
  // Only id + image coming from DB or static list
  const works = [
    { id: 1, img: 'img/Balacany_net.png' },
    { id: 2, img: 'img/balcany2.png' },
    { id: 3, img: 'img/Bird_Spike.png' },
  ];

  return (
    <>
      <GallNav />
      <section className='py-5' style={{ background: '#eef1f5' }}>
        <div className='gallery-container'>
          <h2 className='gallery-title'>Our Genuine Work Gallery</h2>

          {works.length === 0 ? (
            <div className='no-data'>
              <img
                src='/images/empty-gallery.svg'
                alt='No Work'
                className='mb-3'
                style={{ width: '110px', opacity: 0.8 }}
              />
              <p>No work uploaded yet. Check back soon.</p>
            </div>
          ) : (
            <div className='gallery-grid'>
              {works.map((item) => (
                <div key={item.id} className='gallery-item img-thumbnail'>
                  <img
                    src={item.img}
                    alt='work-img'
                    loading='lazy'
                    onError={(e) =>
                      (e.currentTarget.src = '/images/placeholder.jpg')
                    }
                  />
                  <div className='gallery-frame'></div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Scoped styling */}
        <style>{`
        .gallery-container {
          padding: 0 10px;
          max-width: 1200px;
          margin: 0 auto;
        }
        .gallery-title {
          text-align: center;
          color: #1e88e5;
          font-weight: 600;
          margin-bottom: 2rem;
        }
        .gallery-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
          gap: 12px;
        }
        .gallery-item {
          position: relative;
          border-radius: 10px;
          overflow: hidden;
          box-shadow: 0 2px 8px rgba(0,0,0,0.08);
          transition: all 0.3s ease;
          cursor: pointer;
          padding: 0; /* remove thumbnail padding */
        }
        .gallery-item:hover {
          transform: translateY(-4px);
          box-shadow: 0 6px 16px rgba(0,0,0,0.18);
        }
        .gallery-item img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          aspect-ratio: 1 / 1;
          transition: transform 0.3s ease;
        }
        .gallery-item:hover img {
          transform: scale(1.07);
        }
        .gallery-frame {
          position: absolute;
          inset: 0;
          border: 4px solid #fff;
          border-radius: 10px;
          pointer-events: none;
          box-shadow: inset 0 0 0 1px rgba(0,0,0,0.05);
        }
        .no-data {
          min-height: 45vh;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: #777;
          font-size: .95rem;
        }
        @media (max-width: 768px) {
          .gallery-title {
            font-size: 1.45rem;
            margin-bottom: 1.2rem;
          }
          .gallery-container {
            padding: 0 6px;
          }
          .gallery-item {
            border-radius: 8px;
          }
        }
      `}</style>
      </section>
    </>
  );
}

export default Gallery;
